export default __webpack_public_path__ + "static/media/sj-3-rMIN.e937f3ec.avif";